import { Box, Grid } from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import ReportContext, { Types } from "../../context/ReportsContext/ReportContext";
import CreateGraph from "./modals/CreateGraph";
import { useQuery } from "@apollo/client";
import { GET_DASHBOARD_GRAPHS } from "../../Querys/reports/querys";
import GraphMapper from "./components/GraphMapper";
import { AdminContext } from "../../context/AdminContext/AdminContext";
import AddTable from "../../screens/Colaboradores/Colaboradores/CollaboratorTab/AddTable";

  
const ReportDashboard = ({reports}:any) => {
  const [graphs, setGraphs] = useState<any[]>([])
  const [canMakeMoreGraphs, setCanMakeMoreGraphs] = useState(true);
  const { adminState } = useContext(AdminContext)
  const { dispatch } = useContext(ReportContext);
  const { data: graphsDashboard, loading: graphsLoading, refetch } = useQuery(GET_DASHBOARD_GRAPHS, {
    variables:{
      userDashboard: adminState?.Usuario
    },
    fetchPolicy: 'no-cache',
  });
  
  const openGraphModal = () => {

    dispatch({ type: Types.CREATE_GRAPH })
  }

  useEffect(() => {


    if(graphsDashboard && graphsDashboard?.GET_DASHBOARD_GRAPHS?.length > 0){
        setGraphs(graphsDashboard.GET_DASHBOARD_GRAPHS);      
      if(graphsDashboard?.GET_DASHBOARD_GRAPHS?.length >= 8 ){
        setCanMakeMoreGraphs(true);
      }else{
        setCanMakeMoreGraphs(false);
      }
    }else if(graphsDashboard && graphsDashboard?.GET_DASHBOARD_GRAPHS?.length === 0){
      
      setCanMakeMoreGraphs(false);
    }
  },[graphsDashboard])
    
   return(
     <>
        <Box style={{margin:'1rem'}}>
          <Grid
            container
            justify="flex-start"
            alignItems="center"
          >
            <Grid className="btnsInformes">
              <Grid className="btnsInformesFiltros">
                  <AddTable
                    func={openGraphModal}
                    text="Generar Gráfico"
                    type="button"
                    noIcon={true}
                    disabled={canMakeMoreGraphs}
                  />
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Grid container style={{ minHeight:'500px', position:'relative',padding: '20px'}}>
          <Grid item xs={12}>
            {graphsLoading ?
              <div className="c_contenedorPrincipal">
                <div className="contenedorLoadingPrincipal">
                  <div className="loadingPrincipal"></div>
                </div>
              </div>
              :
              graphsDashboard && graphsDashboard?.GET_DASHBOARD_GRAPHS?.length > 0 ?
              <GraphMapper graphsData={graphs} refetch={refetch} />
              :
              <h2>No existen gráficos que mostrar </h2>
            }
          </Grid>
        </Grid>
      


       <CreateGraph reports={reports} refetch={refetch}/>
     </>
   )
}

export default ReportDashboard;
